UC = UC || {};
UC.timesheetComponent = UC.timesheetComponent || {};

UC.timesheetComponent.TimesheetJobs = Backbone.Collection.extend({

  model: UC.timesheetComponent.TimesheetJob

});
